import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import LabeledIncomeStatus from 'components/molecules/labeledStatus/LabaleIncomeStatus';
import { Form } from 'components/organisms';
import {
  CASH_FLOW_TABS,
  cashFlowInitialValues,
} from 'components/organisms/forms/cash-flow/CashFlowForm';
import { useCustomParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import { useDeleteIncome, useGetIncome } from 'services/cash-flow/income';
import { INCOME_TYPE } from 'services/cash-flow/income/types';

const Income = () => {
  const labelId = useCustomParamId('id', '/label');
  const incomeId = useCustomParamId('cashFlowId', `/label/${labelId}/income`);

  const { pathname } = useLocation();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const income = useGetIncome(incomeId);
  const removeIncome = useDeleteIncome();

  const goToListPath = `label/${labelId}/balance`;
  const onGoToEdit = () =>
    navigate(`/label/${labelId}/income/edit/${incomeId}/file`);

  const onRemoveIncome = async (actions: PopupActions) => {
    await removeIncome.mutateAsync(incomeId, {
      onSuccess: () => {
        actions.close();
        navigate('/' + goToListPath);
      },
    });
  };

  return (
    <Form.CashFlow
      initialValues={
        income.data
          ? middleware.income.queryToForm(income.data)
          : cashFlowInitialValues
      }
      onSubmit={() => {}}
      tittle={income.data?.incomeName}
      backPath={goToListPath}
      disableTabs={[CASH_FLOW_TABS.repayments]}
      status={{
        isLoading: income.isLoading,
        displayMode: true,
        refetch: income.refetch,
      }}
      topbarContent={
        <div className='flex items-center w-max'>
          <div>
            {!!income.data && (
              <LabeledIncomeStatus
                status={
                  income.data?.incomeType === INCOME_TYPE.cost
                    ? INCOME_TYPE.basic
                    : income.data?.incomeType
                }
              />
            )}
          </div>

          <Button isClear onlyIcon onClick={onGoToEdit}>
            <Button.Description description={t('button.edit')} />

            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>

          <MagellanPopups.DeleteWarning
            name={income.data?.incomeName}
            onRemove={onRemoveIncome}
          />
        </div>
      }
    />
  );
};

export default Income;
